import $ from 'jquery';
import pageScripts from './pages';
import { Foundation } from 'foundation-sites';
import { Reveal } from 'foundation-sites/js/foundation.reveal';

$(document).foundation();

$(document).ready(function () {
    //Require all components here.
    require('./components/foundation');

    $(".menuBarToggle").click(function () {
        $(this).toggleClass('active');
        $(".menuBarPanel").toggleClass('open');
        $("body").toggleClass('noTouch')
    });

    $(".mobile-nav ul li.menu-item-has-children").click(function () {
        $(this).children('.sub-menu').toggle();
    });

});

$(function () {
    //caches a jQuery object containing the header element
    var header = $(".clear-header");
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 100) {
            header.removeClass('clear-header').addClass("sticky-header");
        } else {
            header.removeClass("sticky-header").addClass('clear-header');
        };
    });

    // var timeout;
    // $('.woocommerce').on('change', 'input.qty', function(){
    // 	if ( timeout !== undefined ) {
    // 		clearTimeout( timeout );
    // 	}
    // 	timeout = setTimeout(function() {
    // 		$("[name='update_cart']").trigger("click");
    // 	}, 1000 ); 
    // });
});

//Clients Owl

$("#clients-owl").owlCarousel({
    loop: true,
    margin: 0,
    responsiveClass: true,
    mouseDrag: true,
    dots: false,
    nav: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: false,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    autoplayHoverPause: false,
    responsive: {
        0: {
            items: 2,
        },
        600: {
            items: 4,
        },
        1000: {
            items: 5,
            loop: true
        }
    }
});

//Testimonial Owl

$("#testimonial-owl").owlCarousel({
    loop: true,
    margin: 0,
    responsiveClass: true,
    mouseDrag: true,
    dots: false,
    nav: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: false,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    autoplayHoverPause: false,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 2,
        },
        1000: {
            items: 5,
            loop: true
        }
    }
});

//Services Owl

$("#services-owl").owlCarousel({
    loop: false,
    margin: 0,
    responsiveClass: true,
    mouseDrag: false,
    dots: false,
    nav: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: false,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    autoplayHoverPause: false,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 2,
        },
        1000: {
            items: 3,
            loop: true
        }
    }
});
